import { render, staticRenderFns } from "./EnvironmentBanner.vue?vue&type=template&id=46e927f5&scoped=true&"
import script from "./EnvironmentBanner.vue?vue&type=script&lang=js&"
export * from "./EnvironmentBanner.vue?vue&type=script&lang=js&"
import style0 from "./EnvironmentBanner.vue?vue&type=style&index=0&id=46e927f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e927f5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
